import { Box, Typography } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import Button from "../inputs/Button";
import { useNavigate } from "react-router-dom";

const AccountStatusBanner = ({ text, onClick, setLocationChanged, mobile }) => {
  const navigate = useNavigate();
  return (
    <Box
      style={{
        position: "absolute",
        left: 0,
        //top: mobile ? undefined : "56px",
        bottom: mobile ? "70px" : "0",
        right: 0,
        backgroundColor: "rgba(255,31,1,0.9)",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "20px",
        zIndex: 1100,
        cursor: "pointer",
      }}
      onClick={() => {
        navigate("/membresia");
        setLocationChanged();
      }}
    >
      <Typography
        style={{
          borderRadius: "10px",
          fontSize: "20px",
          fontFamily: "Urbanist",
          fontWeight: "600",
          textAlign: "center",
          color: "white",
          padding: "10px",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default AccountStatusBanner;
